/* eslint-disable @typescript-eslint/no-explicit-any */
import { withPrefix } from 'gatsby';

/**
 * Dispatch analytics event.
 */
export async function runNavigationEventData(sData: Record<string, any>) {
  if (window.onNavigationUserEvent && sData) {
    try {
      await window.onNavigationUserEvent('header', {
        ...sData,
      });
    } catch (e) {
      console.log(
        'onNavigationUserEvent failed - please check the Navigation SEO script JSON and that a SeoInteractionScript is correctly set up.'
      );
    }
  }
}

export function getLanguageLink(
  pathname: string,
  secondLanguageUrlPrefix: string | undefined,
  isSecondLanguageOnUrl: boolean | undefined
) {
  const pathPrefix = withPrefix('');
  const pathnameWithoutPathPrefix = pathname.replace(pathPrefix, '/');

  if (pathnameWithoutPathPrefix.includes(`/${secondLanguageUrlPrefix}`)) {
    if (isHomeUrl(pathname, secondLanguageUrlPrefix, isSecondLanguageOnUrl)) {
      return pathnameWithoutPathPrefix.replace(
        `/${secondLanguageUrlPrefix}`,
        '/'
      );
    }
    return pathnameWithoutPathPrefix.replace(`/${secondLanguageUrlPrefix}`, '');
  }

  if (isHomeUrl(pathname, secondLanguageUrlPrefix, isSecondLanguageOnUrl)) {
    return `/${secondLanguageUrlPrefix}${pathnameWithoutPathPrefix.slice(
      0,
      pathnameWithoutPathPrefix.length - 1
    )}`;
  }


  return `/${secondLanguageUrlPrefix}${pathnameWithoutPathPrefix}`;
}

export function addSlashIfMissing(
  target: string,
  { missingFrom = 'end' }: { missingFrom?: 'start' | 'end' } = {}
): string {
  if (missingFrom === 'start' && !target.startsWith('/')) {
    return '/' + target;
  }

  if (missingFrom === 'end' && !target.endsWith('/')) {
    return target + '/';
  }

  return target;
}

export function addHashIfMissing(target: string) {
  if (!target.startsWith('#')) {
    return '#' + target;
  }
  return target;
}

export function extractArticleSlug(slug: string): string {
  const segments = slug.split('/');

  if (segments.length === 0 || (segments.length === 1 && segments[0] === '')) {
    return '';
  }

  const lastSegment = segments[segments.length - 1];

  if (lastSegment === '') {
    return segments[segments.length - 2];
  } else {
    return lastSegment;
  }
}

export function getHomeUrl(
  languagePrefix: string | undefined,
  isSecondLanguageOnUrl: boolean | undefined
) {
  if (isSecondLanguageOnUrl) {
    return `/${languagePrefix}`;
  }

  return '/';
}

export function isHomeUrl(
  url: string,
  languagePrefix: string | undefined,
  isSecondLanguageOnUrl: boolean | undefined
) {
  const homeUrl = getHomeUrl(languagePrefix, isSecondLanguageOnUrl);

  return (
    addSlashIfMissing(url, { missingFrom: 'start' }) === withPrefix(homeUrl)
  );
}
